// 禁飞区管理
export default {
    noFlyZoneName: '禁飞区名称',
    noFlyZoneDescription: '禁飞区说明',
    addNoFlyZone: '新增禁飞区',
    status: '状态',
    efficient: '有效',
    invalid: '无效',
    noFlyZoneActivationTime: '禁飞区启用时间',
    noFlyZoneValidityPeriod: '禁飞区有效期',
    position: '定位',
    tip_removeNoFlyZone: '禁飞区被删除后将无法恢复，请谨慎操作！',
    validityPeriod: '有效期',
    number: '编号',
    tip_noFlyZoneName: '禁飞区名称不能为空',
    tip_noFlyZoneIllustrate: '禁飞区说明不能为空',
    tip_noFlyZonePoint: '添加禁飞区点不能小于三个',
    tip_selectDate: '请选择有效期',
}